import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

export const bold: SugarElementInfo = { name: "bold", availableChildren: { type: AvailableChildrenType.Any } };
